import ReactDOM from "react-dom";
import modalStyles from "./modals.module.scss";
import styles from "./ConfirmationBoxModal.module.scss";

function ConfirmationBoxModal({
  text = "Procedere?",
  isOpen,
  onClose,
  onConfirm,
}) {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className={modalStyles.modal_overlay}>
      <div className={modalStyles.modal_content}>
        <div className={styles.container}>
          {text}
          <div className={styles.button_container}>
            <button className="button" onClick={() => onClose()}>
              Annulla
            </button>
            <button
              className="button_var1"
              onClick={() => {
                onConfirm();
                onClose();
              }}
            >
              Conferma
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.getElementById("modal-root")
  );
}

export default ConfirmationBoxModal;
